module.exports = __webpack_public_path__ + "img/wx-free.35b74ca7.png";